import { render, staticRenderFns } from "./CaruselButton.vue?vue&type=template&id=c5882264&scoped=true&"
import script from "./CaruselButton.vue?vue&type=script&lang=js&"
export * from "./CaruselButton.vue?vue&type=script&lang=js&"
import style0 from "./CaruselButton.vue?vue&type=style&index=0&id=c5882264&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5882264",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCard,VChip,VTooltip})
